export default __webpack_public_path__ + "static/media/power_alerts_my_home.af9ab4ca.png";